import { tap } from 'rxjs/operators'
import { orderBy as _orderBy } from 'lodash-es'
import { marketPlaceHierarhcyService } from '../../service/marketplace-hierarchy-service'

export const namespace = 'MARKETPLACE_HIERARCHY'

export const types = {
  GET_MARKETPLACE_GNB_HIERARCHY: 'getMarketPlaceGnbHierarchy',
  SET_MARKETPLACE_GNB_HIERARCHY: 'setMarketPlaceGnbHierarchy',
  GET_MARKETPLACE_LNB_HIERARCHY_LIST: 'getMarketPlaceLnbHierarchyList',
  SET_MARKETPLACE_LNB_HIERARCHY_LIST: 'setMarketPlaceLnbHierarchyList',
  GET_MARKETPLACE_OVERVIEW_HIERARCHY_LIST: 'getMarketPlaceOverviewHierarchyList',
  SET_MARKETPLACE_OVERVIEW_HIERARCHY_LIST: 'setMarketPlaceOverviewHierarchyList'
}

const state = {
  marketPlaceGnbHierarchy: {
    channelingServices: []
  },
  marketPlaceLnbHierarchyList: [],
  marketPlaceOverviewHierarchy: {
    channelingServices: []
  }
}

const mutations = {
  [types.SET_MARKETPLACE_GNB_HIERARCHY](state, payload) {
    state.marketPlaceGnbHierarchy = payload
  },
  [types.SET_MARKETPLACE_LNB_HIERARCHY_LIST](state, payload) {
    state.marketPlaceLnbHierarchyList = payload
  },
  [types.SET_MARKETPLACE_OVERVIEW_HIERARCHY_LIST](state, payload) {
    state.marketPlaceOverviewHierarchy = payload
  }
}

const actions = {
  [types.GET_MARKETPLACE_GNB_HIERARCHY]({ commit }) {
    marketPlaceHierarhcyService.getMarketPlaceGnbHierarchy$().subscribe(hierarchy => {
      commit(types.SET_MARKETPLACE_GNB_HIERARCHY, hierarchy)
    })
  },
  [types.GET_MARKETPLACE_LNB_HIERARCHY_LIST]({ commit }) {
    return marketPlaceHierarhcyService
      .getMarketPlaceLnbHierarchyList$()
      .pipe(
        tap(hierarchyList => {
          commit(types.SET_MARKETPLACE_LNB_HIERARCHY_LIST, _orderBy(hierarchyList, hierarchy => hierarchy.services[0].row, 'asc'))
        })
      )
      .toPromise()
  },
  [types.GET_MARKETPLACE_OVERVIEW_HIERARCHY_LIST]({ commit }) {
    marketPlaceHierarhcyService.getMarketPlaceOverviewHierarchyList$().subscribe(hierarchy => {
      commit(types.SET_MARKETPLACE_OVERVIEW_HIERARCHY_LIST, hierarchy)
    })
  }
}

export const marketPlaceHierarchyStore = {
  state,
  mutations,
  actions,
  namespace,
  types
}
